<div class="ht-selector">
  <mat-form-field floatLabel="never">
    <mat-label>{{ label }}</mat-label>
    <mat-select
      [(ngModel)]="selected"
      (selectionChange)="onChangeOption($event)"
      [multiple]="multiple"
      [compareWith]="isSameOption"
    >
      @if (emptyLabel) {
        <mat-option>{{ emptyLabel }}</mat-option>
      }
      @for (item of options; track item) {
        <mat-option [hidden]="!options" [value]="item.value">{{
          item.label
        }}</mat-option>
      }
      @for (group of groupOptions | keyvalue; track group) {
        <mat-optgroup [label]="group.key" [hidden]="!groupOptions">
          @for (option of group.value; track option) {
            <mat-option [hidden]="!groupOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-optgroup>
      }
    </mat-select>
    @if (hint) {
      <mat-hint>{{ hint }}</mat-hint>
    }
  </mat-form-field>
</div>
